import React from 'react';

var SvgPayoutEuroIcon = function SvgPayoutEuroIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10c0-3.038 2.462-5.5 5.5-5.5s5.5 2.462 5.5 5.5c0 .915-.223 1.777-.617 2.534-.191.368-.048.82.32 1.012.367.19.82.048 1.01-.32.503-.966.787-2.064.787-3.226 0-3.866-3.134-7-7-7s-7 3.134-7 7c0 1.162.284 2.26.786 3.226.192.368.644.51 1.012.32.367-.191.51-.644.32-1.012-.395-.757-.618-1.619-.618-2.534Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 16.25c0-.414-.336-.75-.75-.75h-13c-.414 0-.75.336-.75.75s.336.75.75.75h13c.414 0 .75-.336.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58 9.988c0-.415.336-.75.75-.75h.3c.145-1.258.662-2.171 1.448-2.643.941-.565 2.066-.363 2.792.362.293.293.293.768 0 1.061-.293.293-.768.293-1.061 0-.274-.274-.65-.323-.959-.137-.248.149-.58.534-.707 1.357h1.687c.414 0 .75.335.75.75 0 .414-.336.75-.75.75h-1.687c.127.823.459 1.207.707 1.357.31.185.685.137.959-.138.293-.293.768-.293 1.06 0 .294.293.294.768 0 1.061-.725.726-1.85.927-2.79.363-.787-.472-1.304-1.385-1.448-2.643h-.3c-.415 0-.75-.336-.75-.75Z"
  }));
};
SvgPayoutEuroIcon.displayName = "PayoutEuroIcon";

export { SvgPayoutEuroIcon as S };
